import { render } from "./SMSDetailPage.vue?vue&type=template&id=31cd9bdd"
import script from "./SMSDetailPage.vue?vue&type=script&lang=js"
export * from "./SMSDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__